import { routes } from 'config';
import { useRoutes } from 'react-router-dom';

const AppRouter = () => {
  const router = useRoutes(routes);

  return router;
};

export default AppRouter;
